import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

// Import common translations
import commonTr from "@/constants/locales/common/tr.json"
import commonEn from "@/constants/locales/common/en.json"

// Initialize i18n with only common translations
// Add feature translations as needed when creating new features
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      caches: ["localStorage", "cookie"],
      order: ["querystring", "cookie", "localStorage", "navigator", "htmlTag"],
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    lng: "tr",
    resources: {
      en: {
        translation: commonEn,
      },
      tr: {
        translation: commonTr,
      },
    },
  })

export default i18n
